export default [
  {
    id: '1',
    labelTextColor: '#2C6444',
    labelBackgroundColor: '#BEE9D8',
    topLabelText: 'Via Grant',
    bottomLabelText: 'Minority Deposit Institutions helped',
    badgeText: '',
    badgeValue: '22',
    badgeValueSize: 'small',
    badgeImage:
      'https://www.nerdwallet.com/cdn/landing-pages/CSR/sparkle_50.gif',
    badgeImagePlacement: 'topRight',
    badgeColor: '#EDE8DE',
    badgeTextColor: '#006642',
    description:
      "In 2022 and 2023, NerdWallet's $325,000 grant to Inclusiv's Racial Equity Fund was distributed to 22 Minority Deposit Institution (MDI) credit unions and \"cooperativas.\" Expanding Inclusiv's technical assistance services helps ensure that MDI credit unions have the support necessary to serve almost 20,000 members and hold over $110M in Total Assets.",
    backgroundColor: '#EEF7FF',
    layout: 'vertical',
    textAlign: 'center',
  },
  {
    id: '2',
    labelTextColor: '#02427E',
    labelBackgroundColor: '#AFDCFE',
    topLabelText: 'Via Grant',
    bottomLabelText: 'small businesses and nonprofits  assisted',
    badgeText: '',
    badgeValue: '318',
    badgeValueSize: 'small',
    badgeImage: 'https://www.nerdwallet.com/cdn/landing-pages/CSR/Burst_50.gif',
    badgeImagePlacement: 'topRight',
    badgeColor: '#EDE8DE',
    badgeTextColor: '#02427E',
    description:
      "Divided between 3 CDCUs, NerdWallet's $150,000 grant to Inclusiv's Bay Area Economic Impact Fund in 2021 helped 318 business owners in the Bay Area obtain $43.1M in PPP relief through loan forgiveness. In addition, 405 Bay Area residents received relief in the form of loan forbearance, loan forgiveness, and affordable small-dollar loans totaling almost $10.9M.",
    backgroundColor: '#EEF7FF',
    layout: 'vertical',
    textAlign: '',
  },
  {
    id: '3',
    labelTextColor: '#02143A',
    labelBackgroundColor: '#F7F7F6',
    topLabelText: 'Via Deposit',
    bottomLabelText: 'in impact',
    badgeText: '',
    badgeValue: '$16M',
    badgeValueSize: 'small',
    badgeImage:
      'https://www.nerdwallet.com/cdn/landing-pages/CSR/underline_50.gif',
    badgeImagePlacement: 'bottom',
    badgeColor: '#E5D4EE',
    badgeTextColor: '#02143A',
    description:
      "NerdWallet's deposit of $2 million in Self Help Credit Union created $16 million in community impact.",
    backgroundColor: '#E3FAF2',
    layout: 'vertical',
    textAlign: 'left',
  },
];
